<template>

	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-8 col-md-8 col-sm-12 mt-5 mb-5">
				
                <div class="row ml-5">
                    <div class="col-md-12">

                        <div class="ticket-box">
                            <div class="ticket-header">
                                <h4>ID: {{ ticketData.ticket_id }}</h4>
                            </div>

                            <div class="ticket-title row">
                                <div class="col-md-8 col-lg-9">
                                    <h3 class="mt-1">{{ ticketData.title}} </h3>
                                </div>
                                <div class="col-md-4 col-lg-3 text-right m-0">
                                    <!-- Check If the date is over 1 month or not -->
                                    <p class="createdTime">{{ ticketData.created_at | timeAgo }}</p>
                                </div>
                            </div>
                            
                            <div class="ticket-detail">
                                <p>{{ ticketData.message }}</p>
					        </div>

                            <div class="ticket-replies">

                                <div class="single-reply" v-for="reply in ticketData.replies">
                                    <div class="media">
                                        <avatar :username="reply.user.name" :size="50" backgroundColor="#0F62DF" color="#FFF" class="mr-3"></avatar>
                                        <div class="media-body">
                                            <h5 class="m-0">{{ reply.user.name }} <small class="pull-right reply-date m-0">{{ reply.created_at | timeAgo}}</small></h5>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <small class="pull-left user-role m-0">{{ reply.user.role | displayUserRole }}</small>
                                                </div>
                                            </div>

                                            <div class="reply-message mt-3">
                                                <p class="m-0">{{ reply.message }}</p>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="reply-form" v-if="ticketData.status !== 'Closed'">

                                    <div class="form-group reply-body">
                                        <label for="reply-textarea">Reply to this ticket</label>
                                        <textarea class="form-control message" id="reply-textarea" wrap="hard" name="body" cols="50" rows="10" v-model="reply"></textarea>
                                    </div>

                                    <input type="submit" value="Send reply" class="btn btn-success" v-on:click="addReply">

                                    <input type="submit" value="Close ticket" class="btn btn-danger pull-right" v-on:click="closeTicket">
        
                                </div>

                                <div class="reply-form" v-if="ticketData.status == 'Closed'">

                                    <p class="text-center mb-0">This ticket is closed.</p>
        
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                                            

                                  

			</div>
            <div class="col-lg-4 col-md-4 col-sm-12 mt-5 mb-5">
				
                <div class="row ml-5 mr-5">
                    <div class="col">
                        <div class="ticket-box">
                            <div class="ticket-header">
                                <h4>Ticket information</h4>
                            </div>
                            <table class="table table-hover">
                                <tbody>
                                    <tr>
                                        <th>Ticket ID:</th>
                                        <td class="text-uppercase">{{ ticketData.ticket_id }}</td>
                                    </tr>
                                    <tr>
                                        <th>User:</th>
                                        <td><router-link :to="{ name: 'AdminUserDetails', params: { id: ticketData.owner.id }}">{{ ticketData.owner.name }}</router-link></td>
                                    </tr>
                                    <tr>
                                        <th>Created On:</th>
                                        <td>{{ ticketData.created_at | displayDateTime }}</td>
                                    </tr>
                                    <tr>
                                        <th>Support Department:</th>
                                        <td>{{ ticketData.category.name }}</td>
                                    </tr>
                                    <tr>
                                        <th>Ticket Status:</th>
                                        <td>{{ ticketData.status }}</td>
                                    </tr>
                                    <tr>
                                        <th>Ticket Priority:</th>
                                        <td>{{ ticketData.priority }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

			</div>
		</div>
	</div>

</template>

<script>

    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    var Avatar = require('vue-avatar')

	export default {
		name: 'Support',
		data () {
			return {
                ticketData: [],
                ticket_id: null,
                reply: null,
			}
        },
        components: {
            'avatar': Avatar.Avatar
        },
		mounted() {
            this.ticket_id = this.$route.params.id
            this.getTicket();
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getTicket() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/tickets/" + this.ticket_id, this.getAuthorizationHeader()).then((response) => {
                    _this.ticketData = response.data
                });
            },
            addReply() {

                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/admin/tickets/" + this.ticket_id, {reply: this.reply}, this.getAuthorizationHeader()).then((response) => {
                    console.log(response.data)

                    _this.getTicket();
                });

                this.reply = null
            },
            closeTicket() {

                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/admin/tickets/" + this.ticket_id + "/close", null, this.getAuthorizationHeader()).then((response) => {
                    console.log(response.data)

                    _this.getTicket();
                });

            }
        },
        filters: {
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
            displayUserRole: function(data) {
                if(data == 'videographer') {
					return 'Videographer'
				} else if (data == 'media_purchaser') {
					return 'Media Purchaser'
				} else if (data == 'media_producer') {
					return 'Media Producer'
				} else if (data == 'administrator') {
					return 'Administrator'
				} else if (data == 'superadministrator') {
					return 'Administrator'
				}
            },
            displayDateTime: function(data) {
                return moment.utc(data).local().format('MMMM Do YYYY, h:mm a');
            }
        },
		
	}
</script>

<style scoped>

    .ticket-box {
        background-color: #fff;
    }

    .ticket-header {
        height: 60px;
        padding: 25px 30px;
    }

    .ticket-header h4 {
        color: #8198ac;
        margin: 0px;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: bold;
    }

    .ticket-title {
        background: #f4f9ff;
        padding: 18px 15px 7px;
        margin-right: 0px;
        margin-left: 0px;
    }

    .ticket-detail {
        padding: 15px 30px;
    }

    .ticket-detail p {
        /* color: #849bb3;
        line-height: 28px;
        font-size: 15px; */
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: inherit;
    }

    .ticket-replies {
        border-top: 1px solid #eff3f8;
    }

    .all-replies {
        padding: 30px 30px 0px;
        margin-right: 0px;
        margin-left: 0px;
    }

    .single-reply {
        position: relative;
        padding: 30px 30px;
        border-bottom: 1px solid #eff3f8;
    }

    .createdTime {
        margin: 0;
        margin-top: 5px;
    }

    th {
        padding: 20px 10px 15px 30px;
    }

    .single-reply .media-left, .single-reply .media > .pull-left {
        padding-right: 20px;
    }

    .media-left, .media-right, .media-body {
        display: table-cell;
        vertical-align: top;
    }

    .reply-user-img img {
        width: 50px;
        height: 50px;
        border-radius: 50px;
    }

    .reply-form {
        padding: 30px 30px;
    }

    .reply-form label {
        color: #8198ac;
        margin: 0px;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 10px;
    }

    #reply-textarea {
        height: 120px;
        resize: none;
        border: 1px solid #e6ecf2;
        box-shadow: none;
        -webkit-box-shadow: none;
        overflow: hidden;
    }

</style>
